import { render, staticRenderFns } from "./review-step.vue?vue&type=template&id=62e02e1e&scoped=true&"
import script from "./review-step.vue?vue&type=script&lang=js&"
export * from "./review-step.vue?vue&type=script&lang=js&"
import style0 from "./review-step.vue?vue&type=style&index=0&id=62e02e1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e02e1e",
  null
  
)

export default component.exports